export const colors = [
  '#800000',
  '#E6194B',
  '#FF8B38',
  '#FFE119',
  '#BFEF45',
  '#3CB44B',
  '#42D4F4',
  '#4363D8',
  '#911EB4',
  '#F032E6',
  '#FFD8B1',
  '#AAFFC3',
  '#DCBEFF',
  '#000080',
  '#0000FF',
  '#008080',
  '#00FF00',
  '#00FFFF',
];

export const neutralColors = [
  '#000000',
  '#888888',
  '#808080',
  '#BDBDBD',
  '#E9E9E9',
  '#F5F5F5',
  '#FFFFFF',
];

export function darkenColor(color: string, amount: number) {
  const num = parseInt(color.substring(1), 16); // remove # and convert to number

  let r = Math.max(0, (num >> 16) - amount);
  let b = Math.max(0, ((num >> 8) & 0x00ff) - amount);
  let g = Math.max(0, (num & 0x0000ff) - amount);

  r = Math.min(255, r);
  b = Math.min(255, b);
  g = Math.min(255, g);

  const newColor = g | (b << 8) | (r << 16);
  return '#' + ('000000' + newColor.toString(16)).slice(-6);
}

export const formatClassTitleColor = (color: string): string => {
  color = color.replace('#', '');
  if (color.length < 6) {
    color = color
      .split('')
      .map((chr) => {
        return chr + '0';
      })
      .join('');
  }
  const colorDecimalArr = [
    parseInt(color.substring(0, 2), 16),
    parseInt(color.substring(2, 4), 16),
    parseInt(color.substring(4, 6), 16),
  ];
  const luminosityGivenColor =
    (0.296 * colorDecimalArr[0] +
      0.587 * colorDecimalArr[1] +
      0.144 * colorDecimalArr[2]) /
    255;
  const luminosityWhite = (0.296 * 255 + 0.587 * 255 + 0.144 * 255) / 255;
  return Math.abs(luminosityWhite - luminosityGivenColor) > 0.5
    ? '#FFFFFF'
    : '#000000';
};
